// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_array from "../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as PartnerScoreConfig from "../../../domain/store/PartnerScoreConfig.bs.js";

function LockedScoreSlider(Props) {
  var threshold_values = Props.threshold_values;
  return React.createElement("div", {
              className: "c-locked-score-slider"
            }, React.createElement("div", {
                  className: "locked-slider-track",
                  style: {
                    background: "linear-gradient(90deg, " + Caml_array.get(PartnerScoreConfig.slider_colors, 0) + " " + Caml_array.get(threshold_values, 0) + ", " + Caml_array.get(PartnerScoreConfig.slider_colors, 1) + " " + Caml_array.get(threshold_values, 1) + ", " + Caml_array.get(PartnerScoreConfig.slider_colors, 2) + " 100%)"
                  }
                }));
}

var make = LockedScoreSlider;

export {
  make ,
  
}
/* react Not a pure module */
